<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('webm-to-wav-converter', 'WebM → WAV');

function handleBatchCreated(batchId: string) {
  console.log('[WebM-to-WAV Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[WebM-to-WAV Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[WebM-to-WAV Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[WebM-to-WAV Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[WebM-to-WAV Converter] Credits updated:', credits);
}
</script>
